import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IGroupRepository } from '@/coreInfrastructureModule/interfaces/IGroupRepository';
import { PostAggregateBusinessGroupAdapter } from '../adapter/postAggregateBusinessGroupAdapter';

/**
 * 集計をグループに登録するUseCase
 */
export class AddAggregateBusinessGroupUseCase {
  /**
   * 集計をグループに登録する モック関数
   * @param repository - リポジトリ
   * @param aggregateBusinessIds - 集計ID
   * @param groupId - グループID
   */
  public ExecuteMock = async (
    repository: IGroupRepository,
    aggregateBusinessIds: string[],
    groupId: string
  ): Promise<INetworkResult<void, Error>> => {
    try {
      const request = PostAggregateBusinessGroupAdapter.adaptForRequest(aggregateBusinessIds, groupId);
      const result = await repository.postAggregateBusinessToGroup(request);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('追加に失敗しました'),
        },
      };
    }
  };
}
